import CityPageTemplate from "../city-template/CityPageTemplate";
import { hamiltonConfig } from "./data";

export default function HamiltonPage() {
  return <CityPageTemplate config={hamiltonConfig} />;
}